import React from "react"
import styled from "styled-components"

import ThemeMode from "./ThemeMode"
import Icon from "../../static/message.svg"
import { Link } from "gatsby"

const Header = () => {
  return (
    <React.Fragment>
      <Head>
        <h1>Imran </h1>
        <Link to="#contact">
          <MessageIcon />
        </Link>
        <ThemeToggle data-testid="themeToggle" />
      </Head>
      <Line />
    </React.Fragment>
  )
}

const Head = styled.header`
  padding: 1rem 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 1rem;

  h1 {
    margin: 0;

    @media screen and (max-width: 375px) {
      font-size: 1.25rem;
    }

    @media screen and (max-width: 768px) {
      font-size: 1.75rem;
    }
  }

  @media print {
    display: none;
  }
`

const MessageIcon = styled(Icon)`
  width: 2.5rem;
  padding: 0 10px;
  border-radius: 20px;
  border: none;

  @media screen and (max-width: 475px) {
    width: 1.8rem;
  }
`
const Line = styled.div`
  padding: 0.3px 0;
  width: 46rem;
  margin: 0 auto;
  background-color: #fff;

  @media screen and (max-width: 768px) {
    width: 60%;
  }

  @media screen and (max-width: 475px) {
    width: 62%;
  }
`

const ThemeToggle = styled(ThemeMode)`
  position: absolute;
  right: 0;
`

export default Header
